const changeStatusInputManagementEquip = {
  title: 'INACTIVAR EQUIPOS',
  title2: 'REACTIVAR EQUIPOS',
};

export default changeStatusInputManagementEquip;
